<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalChangeOrdersVisible" :vm-is-valid="!$v.form.$invalid" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("change_orders.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('change_orders.name') })" v-model="form.name" :label='$t("change_orders.name")')
            vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:label='$t("change_orders.type")', v-model='form.type' :danger="$v.form.type.$invalid && $v.form.type.$model" :placeholder='$t("change_orders.type_placeholder")')
            vm-select-item(:value='1', text='Additive')
            vm-select-item(:value='2', text='Deductive')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(type="number" :placeholder='$t("change_orders.amount_placeholder")' :danger="$v.form.amount.$invalid && $v.form.amount.$model" :danger-text="$t('validation.required', { attribute: $t('change_orders.amount') })" v-model="form.amount" :label='$t("change_orders.amount")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("change_orders.date")' :danger="$v.form.date.$invalid && $v.form.date.$model" :danger-text="$t('validation.required', { attribute: $t('change_orders.date') })" v-model="form.date")
      vm-col(v-if="isAdd" vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          input(type="file", ref="file", v-on:change="handleFileUpload()", accept="application/pdf")
</template>
<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalChangeOrders',
  props: {
    form: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  validations () {
    return {
      form: {
        name: {
          required
        },
        type: {
          required
        },
        amount: {
          required
        },
        date: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalChangeOrdersVisible',
      'inOrder'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('change_orders.add') : this.$t('change_orders.edit')
    },
    imageValidate () {
      return this.file.length < 1
    }
  },
  methods: {
    ...mapActions([
      'setModalChangeOrdersVisible',
      'addChangeOrder'
    ]),
    async saveRecord () {
      this.addChangeOrder({ form: this.form, project: this.inOrder, file: this.file })
    },
    close () {
      this.setModalChangeOrdersVisible(false)
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    }
  }
}
</script>
